<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>CURRENCY UNIT<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="currencyunits" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="currencyunitColumns" [selectionField]="'CurrencyUnit_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addCurrencyUnit($event)" (editEntity)="editCurrencyUnit($event)"
            (refreshEntities)="refreshCurrencyUnits($event)" (deleteEntity)="deleteCurrencyUnit($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearCurrencyUnit()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Currency Unit Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                    [fieldName]="'CurrencyUnitName'" [(ngModel)]="entity.CurrencyUnitName"  ngDefaultControl>
                </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'CurrencyUnitCode'" [(ngModel)]="entity.CurrencyUnitCode"  ngDefaultControl>
                </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">                              
                    <dropdown [caption]="'Currency'" [formData]="entity" [data]="currency" [class] = "'form-control'"
                            [mandatory]="false" [filterable]="true" (filterChanged)="getAllCurrency($event)"
                            [(ngModel)]="entity.Currency_Id" [textField]="'CurrencyName'" [valueField]="'Currency_Id'"
                            [fieldName]="'Currency_Id'" [selectedItem]="selectedCurrency" ngDefaultControl>
                        </dropdown>
                </div>
            </div> 
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
            </div> -->
        </div>
       
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Currency Unit Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="CurrencyUnitName" class="label label-1">Currency Unit Name : </label> {{details.CurrencyUnitName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="CurrencyUnitCode" class="label label-1">Code : </label> {{details.CurrencyUnitCode}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="CurrencyName" class="label label-1">Currency Name : </label> {{details.CurrencyName}}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="currencyunits.data" [collapsible]="true" fileName="CurrencyUnit.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="CurrencyUnitName" title="Currency Unit" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="CurrencyUnitCode" title="Code" [width]="200">
    </kendo-excelexport-column>   
    <kendo-excelexport-column field="CurrencyName" title="Currency" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>